<fieldset class="kl-fieldset">
  @if (legend()) {
    <legend class="kl-fieldset__legend">
      <span class="kl-fieldset__legend-text">{{ legend() }}</span>
    </legend>
  }
  <div class="kl-fieldset__body">
    <ng-content />
  </div>
</fieldset>
